"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyEngineError = void 0;
class DummyEngineError extends Error {
    constructor() {
        super("Isolation.Engines.Dummy - Invalid operation: private key not available");
    }
}
exports.DummyEngineError = DummyEngineError;
//# sourceMappingURL=types.js.map